/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ConsultancyLegalTypes, ConsultancyLegalState } from './types';

const INITIAL_STATE: ConsultancyLegalState = {
  dica_legal: {
    dica_legal: [],
    post: [],
  },
  request: {
    get_posts: {
      loading: false,
      loaded: false,
      error: false,
    },
    create: {
      loading: false,
      loaded: false,
      error: false,
    },
    posts: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};
const reducer: Reducer<ConsultancyLegalState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case ConsultancyLegalTypes.GET_DICAS_REQUEST:
        draft.request.get_posts = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConsultancyLegalTypes.GET_DICAS_SUCCESS:
        draft.dica_legal.dica_legal = result?.data?.legal_tips;
        draft.request.get_posts = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConsultancyLegalTypes.GET_DICAS_FAILURE:
        draft.request.get_posts = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConsultancyLegalTypes.GET_CREATE_REQUEST:
        draft.request.create = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConsultancyLegalTypes.GET_CREATE_SUCCESS:
        draft.request.create = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConsultancyLegalTypes.GET_CREATE_FAILURE:
        draft.request.create = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConsultancyLegalTypes.GET_POSTS_REQUEST:
        draft.request.posts = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConsultancyLegalTypes.GET_POSTS_SUCCESS:
        draft.dica_legal.post = Array(result?.data);
        draft.request.posts = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConsultancyLegalTypes.GET_POSTS_FAILURE:
        draft.request.posts = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
